module.exports = __webpack_public_path__ + "img/intro_logo.6a5acf64.png";